export default __webpack_public_path__ + "src/images/create-account.svg";